/**
 * Use Zakeke hook
 * @module useZakeke
 */

import { useContext } from "react";
import { context } from "../state/provider";

/**
 * The entry point to use all Zakeke features
 * @returns {import("../state/providerValue").Zakeke} Contains all the data and methods to control a Zakeke configuration
 */
export const useZakeke = () => {
    const value = useContext(context);

    if (!value)
        throw new Error('Invalid Zakeke state. Ensure you have wrapped your component with the ZakekeProvider component and you are not calling useZakeke outside of it.');

    return value;
}

